import { z } from 'zod/v3';

export const paymentConfigSchema = z.object({
  downPaymentPercentage: z
    .number({ required_error: 'Informe a porcentagem de entrada' })
    .min(1, 'Mínimo 1%')
    .max(100, 'Máximo 100%'),
  installments: z
    .number({ required_error: 'Selecione o número de parcelas' })
    .int()
    .min(1, 'Mínimo 1 parcela')
    .max(12, 'Máximo 12 parcelas'),
});

export type PaymentConfigFormData = z.infer<typeof paymentConfigSchema>;
